import axios from "axios";
import {
  FETCH_PROVEEDORES_REQUEST,
  FETCH_PROVEEDORES_SUCCESS,
  FETCH_PROVEEDORES_FAILURE,
} from "./types";
import { PATH } from "../../utils";

const api = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const actionProveedoresGet = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_PROVEEDORES_REQUEST });
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const res = await api.get("/proveedores", { headers: authHeader(), params: cleanParams });
    const items = Array.isArray(res.data) ? res.data : res.data?.items ?? [];
    dispatch({ type: FETCH_PROVEEDORES_SUCCESS, payload: items });
  } catch (err) {
    const msg = err?.response?.data?.detail || err.message || "Error al cargar proveedores";
    dispatch({ type: FETCH_PROVEEDORES_FAILURE, payload: { error: msg } });
  }
};

export const apiProveedoresInstance = api;
export { authHeader as authHeaderProveedores };
